import api from "@/lib/api";

// ============================================================================
//  Packs habilitados (descuentos por pack).
//
//  Viajan embebidos en /api/prices/matrix, que el front ya pedia siempre para los
//  precios. Antes se pedian en un segundo request (/api/pack-discounts/enabled)
//  que acompaniaba SIEMPRE al de precios: era el 19% del trafico de la API.
//
//  El fallback al endpoint viejo solo dispara si la matrix no trae `packs` (back
//  todavia sin deployar, o rollback del back). En condiciones normales no hace
//  ninguna request extra. Es la red de seguridad para que un front nuevo contra un
//  back viejo NO muestre los precios sin el descuento de pack.
//
//  Si el fallback falla, propaga el error (no devuelve []) para no mostrar precios sin
//  descuento de forma silenciosa: es lo que pasaba antes, cuando el request de packs
//  viajaba dentro del mismo Promise.all que el de precios.
//
//  CONTRATO (importante, es codigo de dinero): resolve los packs ANTES de commitear el
//  estado de precios, y despues seteá los dos juntos. Si seteas los precios primero y
//  esto tira error, la pantalla queda con precios de pack SIN descuento mientras el back
//  los cobra CON descuento. Con packs=[] no se muestra "—": se muestra un precio mal.
//
//      const packs = await resolvePacks(pricesRes, { signal });   // primero
//      setPricesMatrix(pricesRes?.data ?? null);                  // y recien despues
//      setPackDiscounts(packs);                                   // los dos juntos
// ============================================================================
export async function resolvePacks(pricesRes, config) {
  const embedded = pricesRes?.data?.packs;
  if (Array.isArray(embedded)) return embedded;

  const res = await api.get("/api/pack-discounts/enabled", config);
  return Array.isArray(res?.data) ? res.data : [];
}
